import axios from "axios";

class LapiService {
  private static readonly cache = new Map<string, string>();

  public static clearCache() {
    LapiService.cache.forEach((value) => URL.revokeObjectURL(value));
    LapiService.cache.clear();
  }

  public static async getLapiImage(
    src: string,
    token: string,
    size?: number
  ): Promise<string> {
    const key = `${src}${size === undefined ? "" : `-${size}x${size}`}`;

    const cachedSrc = LapiService.cache.get(key);
    if (cachedSrc !== undefined) return cachedSrc;

    try {
      const res = await axios({
        method: "GET",
        url: src,
        params: {
          width: size,
          height: size,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });

      const cachedSrc = URL.createObjectURL(res.data);
      LapiService.cache.set(key, cachedSrc);

      return cachedSrc;
    } catch (error) {
      throw error;
    }
  }
}
export default LapiService;
